import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import AppLayout from './layouts';
import { AuthProvider } from './context/AuthContext';
import LoginPage from './pages/LoginPage';
import TestRunsPage from './pages/TestRunsPage';
import SettingsPage from './pages/SettingsPage';
import TestCasesPage from './pages/TestCasesPage';
import TestCaseGroupsPage from './pages/TestCaseGroupsPage';
import RunDetailPage from './pages/RunDetailPage';
import LiveRunPage from './pages/LiveRunPage';
import TriagePage from './pages/TriagePage';
import GroupHistoryPage from './pages/GroupHistoryPage';
import MetricsPage from './pages/MetricsPage';
import ProfilePage from './pages/ProfilePage';
import ComparePage from './modules/compare/ComparePage';
import CompareReportPage from './modules/compare/CompareReportPage';
import HomePage from './pages/HomePage';
import ReleaseReadinessPage from './pages/analysis/ReleaseReadinessPage';
import FailureAnalysisPage from './pages/analysis/FailureAnalysisPage';
import TestingGapsPage from './pages/analysis/TestingGapsPage';

function AppRoutes() {
  return (
    <AppLayout>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/triage" element={<TriagePage />} />
        <Route path="/metrics" element={<MetricsPage />} />
        <Route path="/test-runs" element={<TestRunsPage />} />
        <Route path="/test-runs/:runId" element={<RunDetailPage />} />
        <Route path="/test-runs/:runId/live" element={<LiveRunPage />} />
        <Route path="/test-case-groups" element={<TestCaseGroupsPage />} />
        <Route path="/test-cases/:group" element={<TestCasesPage />} />
        <Route path="/test-groups/:group/history" element={<GroupHistoryPage />} />
        <Route path="/compare" element={<ComparePage />} />
        <Route path="/compare/report" element={<CompareReportPage />} />
        <Route path="/compare-legacy" element={<Navigate to="/compare" replace />} />
        <Route path="/analysis" element={<Navigate to="/analysis/release-readiness" replace />} />
        <Route path="/analysis/release-readiness" element={<ReleaseReadinessPage />} />
        <Route path="/analysis/failure-analysis" element={<FailureAnalysisPage />} />
        <Route path="/analysis/testing-gaps" element={<TestingGapsPage />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AppLayout>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/*" element={<AppRoutes />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
